"use client";

import pendingSearch from "@/lib/pendingSearch";
import { useSyncExternalStore } from "react";

/** The staged search, re-rendering whenever it is written. */
export function usePendingSearch() {
  return useSyncExternalStore(
    pendingSearch.subscribe,
    pendingSearch.get,
    pendingSearch.get,
  );
}
